<template>
  <div id="tab5">
    <form name="generalForm" novalidate @submit.prevent="save">
      <div v-if="canShowAddInstrumentSeccion && canEditTab6" class="row">
        <div class="col-12 mt-4">
          <div class="row-group mb-4">
            <div class="row">
              <div class="col-lg-12">
                <Error
                  is-alert-mode
                  class="mt-0"
                  :message="
                    '<b>Favor de especificar algún instrumento diferente a los utilizados en la determinación de elegibilidad anterior para la cual el estudiante resultó no elegible.</b>'
                  "
                />
              </div>
            </div>
          </div>
          <SectionTitle :has-line="true" content="Añadir Instrumento" />
          <ValidationObserver ref="formInstrumentsValidator">
            <div class="row-group mb-4">
              <div class="row ml-3">
                <div class="col-lg-2">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    mode="eager"
                    name="(fecha)"
                  >
                    <CustomDatePicker
                      id="txtPerformedDate"
                      v-model="instrumentInfo.PerformedDate"
                      class-container="w-100"
                      label="Fecha:"
                      :placeholder="'DD/MM/YYYY'"
                      :max-date="new Date()"
                      :error="errors[0]"
                      custom-error-msg="Campo Requerido."
                      class="w-100"
                      :use-utc="false"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-lg-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    mode="eager"
                    name="instrumento"
                    rules="required"
                  >
                    <custom-drop-down
                      id="ddlInstrumentId"
                      v-model="instrumentInfo.InstrumentId"
                      fieldname="name"
                      fieldkey="id"
                      placeholder="Seleccione"
                      :options="instrumentsOptions"
                      label="Instrumento:"
                      custom-error-msg="Campo Requerido."
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
                <div v-if="showPerformedBy" class="col-lg-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    mode="eager"
                    name="performedby"
                    rules="required"
                  >
                    <CustomInput
                      id="txtPerformedBy"
                      v-model="instrumentInfo.PerformedBy"
                      label="Realizado por: "
                      required
                      custom-error-msg="Campo Requerido."
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
                <div class="col-lg-3" style="margin-top: 20px">
                  <ActionButton
                    id="btnAddInstrument"
                    variant="success m-2 pl-3 pr-3"
                    @click="AddInstrument()"
                  >
                    Añadir
                  </ActionButton>
                </div>
              </div>
              <div class="row ml-3">
                <div class="col-lg-12" />
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
      <div v-if="canShowSelectedInstrumentSeccion" class="row">
        <div class="col-12 mt-4">
          <SectionTitle :has-line="true" content="Instrumentos Seleccionados" />
          <div
            v-for="(item, index) in postRegistryInstruments"
            :key="index"
            class="row"
          >
            <custom-callout class="col-12 pt-3">
              <div class="row">
                <div class="col-12 pl-5 pr-4">
                  <div class="row">
                    <div class="col-md-3 col-sm-12 pt-0">
                      <custom-tupla
                        name="Instrumento:"
                        :text="item.instrumentName"
                      />
                    </div>
                    <div class="col-md-3 col-sm-12 pt-0">
                      <custom-tupla
                        name="Fecha:"
                        :text="$formatDate(item.performedDate)"
                      />
                    </div>
                    <div class="col-md-4 col-sm-12 pt-0">
                      <custom-tupla
                        v-if="
                          item.performedBy != null && item.performedBy != ''
                        "
                        name="Realizado por:"
                        :text="item.performedBy"
                      />
                    </div>
                    <div class="col-md-2 col-sm-12 pt-0">
                      <div v-if="canShowAddInstrumentSeccion && canEditTab6">
                        <ActionButton
                          variant="outline-danger mt-2"
                          i="fa fa-minus-circle"
                          text="Remover"
                          @click="
                            RemoveInstrument(
                              item.regStudentPostRegistryId,
                              item.instrumentId
                            )
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </custom-callout>
          </div>
        </div>
      </div>
      <CollapsableContainer
        :title="`Evaluación Inicial`"
        class="mt-2"
        :collapse="sectionCollapse.initialEvaluation"
      >
        <div class="ml-3">
          <div v-if="canShowEvaluationSeccion" class="row">
            <div class="col-12 mt-4">
              <SectionTitle :has-line="true" :content="firstSectionTitle" />
              <ValidationObserver ref="formValidator">
                <div class="ml-4">
                  <div v-if="!isInitialEvaluationReadOnly">
                    <div
                      v-if="canShowInitialEvaluationValidationMessage"
                      class="row-group"
                    >
                      <div class="row">
                        <div class="col-lg-12">
                          <Error
                            is-alert-mode
                            class="mt-0"
                            :message="
                              '<b>' +
                                initialEvaluationValidationMessage +
                                '</b>'
                            "
                          />
                        </div>
                      </div>
                    </div>
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="(fecha)"
                    >
                      <CustomDatePicker
                        id="txtEvaluationDate"
                        v-model="model.postInitialEvaluationDate"
                        label="Fecha:"
                        :placeholder="'DD/MM/YYYY'"
                        :error="isValidDate ? errors[0] : resources['0527']"
                        :custom-error-msg.sync="resources['17057']"
                        :max-date="new Date()"
                        class="w-25"
                        :use-utc="false"
                        :disabled="
                          isReadOnlyEligibilitySection ||
                            !canEditTab6 ||
                            readOnlyWithSpecificRole
                        "
                        @input="validDate"
                      />
                    </ValidationProvider>

                    <div class="mt-4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        name="(comentario)"
                      >
                        <strong>Comentario:</strong>
                        <CustomTextArea
                          :id="'initalDescription'"
                          v-model="model.postInitialEvaluationDescription"
                          style="width: 100%"
                          placeholder="Escribir comentario..."
                          :maxlength="500"
                          :classes="['eq-field', 'text-left']"
                          :rows="5"
                          :disabled="
                            isReadOnlyEligibilitySection ||
                              !canEditTab6 ||
                              readOnlyWithSpecificRole
                          "
                          :error="errors[0]"
                          :custom-error-msg="resources['17021']"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                  <div v-else>
                    <div>
                      <strong>Fecha:</strong>
                      <p class="reglular-text">
                        {{ initialDate }}
                      </p>
                    </div>
                    <div>
                      <strong>Comentario:</strong>
                      <p class="reglular-text">
                        {{ model.postInitialEvaluationDescription }}
                      </p>
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>

          <!-- Razón de Coordinación Tardía -->
          <div
            v-if="
              canShowEligibilitySection &&
                (model.isDeterminationLate || this.isRegistryBreachOver)
            "
            class="row"
          >
            <div class="col-12 mt-4">
              <SectionTitle
                content="Razón de Coordinación Tardía de Evaluación Inicial "
                :has-line="true"
              />
              <ValidationObserver ref="lateEvaluationReasonFormValidator">
                <p class="ml-3">
                  Favor de seleccionar la razón para que la coordinación de la
                  evaluación se haya realizado fuera de término
                </p>
                <div class="col-8">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="Motivo de la evaluación tardía"
                  >
                    <CustomDropDown
                      v-model="model.lateEvaluationReason"
                      class="w-50 d-inline"
                      :error="errors[0]"
                      label="Razón:"
                      placeholder="Seleccionar la razón"
                      fieldkey="id"
                      fieldname="name"
                      :options="tardinessReasonOptions"
                      :disabled="
                        isReadOnlyTardinessSection ||
                          !canEditTab6 ||
                          readOnlyWithSpecificRole
                      "
                      :custom-error-msg="'Favor seleccionar la razón'"
                    />
                  </ValidationProvider>
                </div>
                <div v-if="showLateEvaluationReasonDescription">
                  <div class="mt-3 mb-3 ml-3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="Descripción del Motivo de la evaluación tardía"
                    >
                      <CustomTextArea
                        v-model="model.lateEvaluationReasonDescription"
                        label="Comentario:"
                        :maxlength="3000"
                        :rows="5"
                        placeholder="Escribir comentario..."
                        :error="errors[0]"
                        :disabled="
                          isReadOnlyTardinessSection ||
                            !canEditTab6 ||
                            readOnlyWithSpecificRole
                        "
                        :custom-error-msg="'Favor escriba una descripción.'"
                      />
                    </ValidationProvider>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>

          <!-- Razón por la cual no se envió a Remedio Provisional -->
          <div
            v-if="
              canShowEligibilitySection &&
                (model.isDeterminationLate || this.isRegistryBreachOver)
            "
            class="row"
          >
            <div class="col-12 mt-4">
              <SectionTitle
                content="Razón por la cual no se envió a Remedio Provisional "
                :has-line="true"
              />
              <ValidationObserver ref="rpReasonFormValidator">
                <p class="ml-3">
                  Favor de seleccionar la razón por la cual no se envió a
                  Remedio Provisional
                </p>
                <div class="col-8">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    name="Motivo de la evaluación tardía"
                  >
                    <CustomDropDown
                      v-model="model.rpLateEvaluationReason"
                      class="w-50 d-inline"
                      :error="errors[0]"
                      label="Razón:"
                      placeholder="Seleccionar la razón"
                      fieldkey="id"
                      fieldname="name"
                      :options="tardinessInfo.rpTardinessReasons"
                      :disabled="
                        isReadOnlyTardinessSection ||
                          !canEditTab6 ||
                          readOnlyWithSpecificRole
                      "
                      :custom-error-msg="'Favor seleccionar la razón'"
                    />
                  </ValidationProvider>
                </div>
                <div v-if="showRPLateEvaluationReasonDescription">
                  <div class="mt-3 mb-3 ml-3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      rules="required"
                      name="Descripción del Motivo de la evaluación tardía"
                    >
                      <CustomTextArea
                        v-model="model.rpLateEvaluationReasonDescription"
                        label="Comentario:"
                        :maxlength="3000"
                        :rows="5"
                        placeholder="Documente la razón por la que no fue referido a Remedio Provisional en termino..."
                        :error="errors[0]"
                        :disabled="
                          isReadOnlyTardinessSection ||
                            !canEditTab6 ||
                            readOnlyWithSpecificRole
                        "
                        :custom-error-msg="'Favor escriba una descripción.'"
                      />
                    </ValidationProvider>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </CollapsableContainer>

      <CollapsableContainer
        :title="`Determinación de Elegibilidad Inicial`"
        class="mt-2"
        :collapse="sectionCollapse.initialEligibilityDetermination"
        v-if="hasInitialEvaluationFilled"
      >
        <div class="ml-3">
          <!--Documentos de respaldo-->
          <div v-if="canShowEligibilitySection" class="row">
            <div class="col-12 mt-4">
              <section-title
                content="Documentos de Respaldo al Proceso de Determinación"
                :has-line="true"
              />
            </div>
            <div class="col-12">
              <BackupDocument
                :documents="backupDocument.data"
                :document-types="backupDocument.documentTypes"
                :disabled="
                  isReadOnlyDeterminationSection ||
                    !canEditTab6 ||
                    readOnlyWithSpecificRole
                "
                :get="backupDocument.get"
                @files="gettingBackupDocument"
              />
            </div>
          </div>

          <!-- Informacion de Evaluaciones -->
          <div v-if="canShowEligibilitySection" class="row">
            <div class="col-12">
              <section-title
                content="Información de Evaluaciones"
                :has-line="true"
              />
            </div>

            <div class="col-12">
              <div class="mx-3">
                <EvaluationInformationLayout
                  v-model="evaluationInformation.evaluationsModel"
                  has-option-determinate
                  :evaluation-saved="false"
                  :get="evaluationInformation.get"
                  :get-validation="evaluationInformation.getValidation"
                  :evaluation-information-external-data="
                    evaluationInformation.evaluationInformationExternalData
                  "
                  :disabled="
                    isReadOnlyDeterminationSection ||
                      IsEvaluationsDisabled ||
                      !canEditTab6
                  "
                  :read-only="readOnlyWithSpecificRole"
                  :evaluation-service-type="evaluationServiceType"
                  :is-initial-post-registry="isInitialPostRegistry"
                  :add-action="redirectToStudentEvaluation"
                  :show-as-discussion="evaluationInformation?.showAsDiscussion"
                  :discussionCollections="
                    evaluationInformation?.discussionCollections
                  "
                  @selected="onSelected"
                  @determinated="onDeterminated"
                  @validations="onValidations"
                  @data="gettingEvaluationInformation"
                  @getRef="getObserver"
                  @on-evaluation-data-changed="onEvaluationDataChanged"
                  @go-to-add-student-evaluation="goToAddStudentEvaluation"
                />
              </div>

              <Error
                v-if="!this.HasValidEvaluationSelection"
                variant="no-border error-margin-left mb-2"
                :message="resources['22144']"
              />

              <Error
                v-if="
                  !this.evaluationInformation.allEvaluationsAcceptedOrRejected
                "
                variant="no-border error-margin-left mb-2"
                :message="resources['22145']"
              />

              <Error
                v-if="serverEvaluationErrorMessage != null"
                variant="no-border error-margin-left mb-2 custom-errors-list"
                :message="serverEvaluationErrorMessage"
              />
            </div>
          </div>

          <!-- Determinación de Elegibilidad -->
          <div
            v-if="elegibilityDetermination.show || canShowDeterminationSection"
            class="row"
          >
            <EligibilityDetermination
              ref="eligibilityDetermination"
              :called-from="'post-registry'"
              :date-eligibility="
                model.eligibilityInfo != null
                  ? model.eligibilityInfo.eligibilityDeterminationDate
                  : new Date()
              "
              :placement-committe-id="model.eligibilityInfo.placementCommiteeId"
              :date-registration="model.registrationDate"
              :get="elegibilityDetermination.eligibilityInfo"
              :registry="studentPreRegistry"
              :student-registry-status="model.studentStatus"
              :is-initial-registry="isInitialPostRegistry"
              :get-info="elegibilityDetermination.get"
              :disabled="
                isReadOnlyDeterminationSection ||
                  IsDeterminationDisabled ||
                  !canEditTab6 ||
                  readOnlyWithSpecificRole
              "
              :field-model="fieldModelElegibility"
              :tardiness-info="tardinessInfo"
              has-validation-pending
              @getFieldModel="setFieldModelElegibility"
              @getRef="getObserver"
              @data="gettingEligibilityDetermination"
              @on-eligibility-data-changed="onEligibilityDataChanged"
            />
          </div>

          <!-- Firma de Participantes -->
          <div v-if="canShowEligibilitySection" class="col-12">
            <SectionTitle has-line content="Firma de Participantes" />
            <ValidationObserver ref="signatureObserver" slim>
              <Tab9ParticipantSignatures
                ref="participantSignatures"
                :key="componentKey"
                :value="signatureList"
                :options="availableSignatureOptions"
                :is-draft="
                  !isReadOnlyDeterminationSection &&
                    !IsDeterminationDisabled &&
                    canEditTab6 &&
                    !readOnlyWithSpecificRole
                "
                :participation-types="participationTypeList"
                :alternate-participations="alternateParticipationTypeList"
                @addSignature="addSignature()"
                @deleteSignature="deleteSignature"
              />
            </ValidationObserver>
          </div>
          <ValidationObserver ref="termsResponsability">
            <!-- Certificación de procedimientos -->
            <div class="mt-5">
              <div class="mt-3 tag-badge pl-2">
                <span class="dot text-center">
                  <i
                    class="far fa-check-circle orange-icon orange-icon-badge-align"
                  />
                </span>
                <span class="tag-badge-title py-1 pl-2">
                  Certificación de procedimientos
                </span>
              </div>
            </div>
            <div class="row mx-1">
              <div class="col-12 px-1">
                <div class="border-box">
                  Certifico por este medio, que este referido podrá encontrarse
                  en el expediente físico del estudiante firmado por todas las
                  partes involucradas. (0502)
                </div>
              </div>
              <div class="col-12 px-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="checkboxConditions"
                  rules="required"
                >
                  <div class="row mx-1">
                    <div
                      class="border-box gray"
                      :class="{ error: errors.length > 0 }"
                    >
                      <div class="col-12 px-0 py-0">
                        <div class="custom-control custom-checkbox">
                          <div class="custom-control custom-checkbox">
                            <input
                              id="checkboxConditions"
                              v-model="isTermsResponsabilityAccept"
                              :disabled="isReadOnlyEligibilitySection"
                              type="checkbox"
                              class="custom-control-input"
                              name="checkboxConditions"
                            />
                            <label
                              class="custom-control-label pl-3"
                              for="checkboxConditions"
                            >
                              Acepto
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-show="errors.length > 0" class="row mt-1">
                      <div class="col-12">
                        <i class="fa fa-times-circle text-red pr-2" />
                        <span class="invalid">
                          Favor certificar los términos y responsabilidades
                        </span>
                      </div>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </ValidationObserver>
        </div>
      </CollapsableContainer>
      <CollapsableContainer
        :title="`PEI Inicial - Ubicación`"
        v-if="canShowPeiInitialLocationSection"
        class="mt-2"
        :collapse="sectionCollapse.initialPEILocation"
      >
        <div class="ml-3">
          <!-- PEI Initial - Location -->
          <PeiInitialLocation
            v-if="canShowPeiInitialLocationSection"
            v-model="peiInitialLocation"
            :showTitle="false"
            :student-data="model"
            :read-only="isReadOnlyPeiInitialLocationSection || !canEditTab6"
            :date-eligibility="peiInitialLocation.eligibilityDeterminationDate"
            :pei-initial-date-read-only="
              canModifyPeiInitialDate || !canEditTab6
            "
            :post-register-location-read-only="
              canModifyPostRegisterLocation || !canEditTab6
            "
            @getRef="getObserver"
          />

          <div class="row pt-5 pb-5" />
          <FixedBottomSaveButton
            v-if="saveButtonVisibility"
            id="btnBottomVisibilitySave"
          />
        </div>
      </CollapsableContainer>
    </form>
  </div>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import CustomTupla from '@/components/common/CustomTupla';
import { ActionButton, CustomInput } from '@/components/common';
import { CustomDropDown } from '@/components/common';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { SectionTitle } from '@/components/pei/shared';
import { CustomDatePicker } from '@/components/common';
import CustomTextArea from '@/components/common/CustomTextArea';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import moment from 'moment';
import BackupDocument from '@/components/studentEvaluation/BackupDocument';
import EvaluationInformationLayout from '@/components/studentEvaluation/EvaluationInformationLayout';
import EligibilityDetermination from '@/components/triannualDeterminationProcess/components/EligibilityDetermination';
//import ParticipantSignatures from "@/components/studentEvaluation/participantSignatures/ParticipantSignatures";
import Tab9ParticipantSignatures from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures';
import PeiInitialLocation from '@/components/pei/PeiInitialLocation';
import FixedBottomSaveButton from '@/components/common/FixedBottomSaveButton';
import objectToFormData from 'object-to-formdata';
import StudentStatuses from '@/utils/constants/student/studentStatuses.js';
import tardyRegistrationReasons from '@/utils/constants/pei/peiTardyRegistrationReasons.js';
import resourcesService from '@/services/resources.js';
import Error from '@/components/common/Error';
import { createNamespacedHelpers } from 'vuex';
import studentService from '@/services/student';
const { mapState, mapMutations } = createNamespacedHelpers('$_student');
import userRole from '@/utils/constants/userRoles';
import CollapsableContainer from '@/components/common/CollapsableContainer.vue';
//Apis or Services
import signatureService from '@/modules/common/signature.api';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import {
  getEvaluationDiscussionStatus,
  getRejectionReasonsV2,
} from '@/modules/common/code.api.js';
import { discussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';

export default {
  name: 'Tab6',
  mixins: [alert],
  components: {
    ValidationProvider,
    ValidationObserver,
    SectionTitle,
    CustomDatePicker,
    CollapsableContainer,
    CustomTextArea,
    BackupDocument,
    EvaluationInformationLayout,
    EligibilityDetermination,
    //ParticipantSignatures,
    Tab9ParticipantSignatures,
    PeiInitialLocation,
    FixedBottomSaveButton,
    Error,
    CustomDropDown,
    CustomInput,
    ActionButton,
    CustomTupla,
    CustomCallout,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      sectionCollapse: {
        initialEvaluation: false,
        initialEligibilityDetermination: false,
        initialPEILocation: false,
      },
      fieldModelElegibility: null,
      isRegistryBreachOver: false,
      readonly: false,
      throwSaved: false,
      initialDateErrorMessage: '',
      canShowInitialEvaluationValidationMessage: false,
      initialEvaluationValidationMessage: '',
      evaluationServiceType: null,
      isInitialPostRegistry: null,
      isTermsResponsabilityAccept: null,
      canModifyPostRegisterLocation: false,
      canModifyPeiInitialDate: false,
      model: {
        regStudentId: null,
        studentSieId: 0,
        studentStatus: 0,
        academicYearId: 0,
        postInitialEvaluationDate: new Date(),
        postInitialEvaluationDescription: '',
        regStudentPostRegistryId: null,
        isDeterminationLate: false,
        tardinessReasons: [],
        rpTardinessReasons: [],
      },
      // Data for component backupDocument.
      backupDocument: {
        files: [],
        documentTypes: [
          { id: 1, name: 'Minuta' },
          { id: 2, name: 'Otros' },
        ],
        // Variables to save component data.
        data: {
          files: [],
          types: [],
        },
      },
      // Data for component evaluationInformation.
      evaluationInformation: {
        // Validations.
        evaluationAcceptedAndDetermined: true,
        allEvaluationsAcceptedOrRejected: true,
        // Variable to save component data.
        data: null,
        // Flags getting event.
        get: false,
        getValidation: false,
        evaluationsModel: null, //JA: Temporal refactor fix, this is used as the real model for the Evaluations Component,
        showAsDiscussion: false,
        discussionCollections: {
          discussionStatuses: [],
          rejectionReasons: [],
          allRejectionReasons: [],
        },
      },
      // Data for component elegibilityDetermination.
      elegibilityDetermination: {
        show: false,
        eligibilityInfo: {
          requiredByPostRegistry: true,
        },
        // Variable to save component data.
        data: null,
        // Flags getting event.
        get: false,
      },
      // Data for component participantSignatures.
      peiInitialLocation: {
        eligibilityDeterminationDate: null,
        postAlternatePlacementDate: null,
        postAlternatePlacementDescription: null,
        peiAlternatePlacement: null,
        generalClosedDate: new Date(),
        // Variable to save component data.
        peiInitialDate: new Date(),
        initialPeiComment: '',
      },
      instrumentInfo: {
        instrumentId: null,
        instrumentName: null,
        performedDate: null,
        performedBy: null,
        initialIstrumentFlag: null,
        isEvaluationFlag: null,
        regStudentPostRegistryId: null,
      },
      observers: {},
      evaluations: [],
      instrumentsOptions: [],
      postRegistryInstruments: [],
      isValidDate: true,
      resources: [],
      selectedInstrumentId: null,
      showPerformedBy: true,
      serverEvaluationErrorMessage: null,

      //JA: Evaluation information (Used in validations only, this will change when the component is refactored)
      selectedEvaluationModels: [],
      eligibilityInfoModel: null,
      HasValidEvaluationSelection: true,
      selectedAllEvaluations: true, // Just to hide the inicial state
      IsEvaluationsDisabled: false,
      IsDeterminationDisabled: false,
      canEditTab6: store.getters.HasPermission('registry.editTab6'),

      //signature Managment properties
      signatureCounter: 0,
      signatureList: [],
      signatures: [],
      elegibilitySignatureList: null,
      componentKey: 0,
      availableSignatureOptions: [],
      participationTypeList: [],
      alternateParticipationTypeList: [],
      validateComponent: false,
      //End Section VI
    };
  },
  methods: {
    saveEditedData() {
      this.$store.commit('setRegistryTriannualEvaluation', {
        sectionCollapse: {
          ...this.sectionCollapse,
          initialEligibilityDetermination: false,
        },
        fieldModelElegibility: this.fieldModelElegibility,
        isRegistryBreachOver: this.isRegistryBreachOver,
        readonly: this.readonly,
        throwSaved: this.throwSaved,
        initialDateErrorMessage: this.initialDateErrorMessage,
        canShowInitialEvaluationValidationMessage: this
          .canShowInitialEvaluationValidationMessage,
        initialEvaluationValidationMessage: this
          .initialEvaluationValidationMessage,
        evaluationServiceType: this.evaluationServiceType,
        isInitialPostRegistry: this.isInitialPostRegistry,
        isTermsResponsabilityAccept: this.isTermsResponsabilityAccept,
        canModifyPostRegisterLocation: this.canModifyPostRegisterLocation,
        canModifyPeiInitialDate: this.canModifyPeiInitialDate,
        model: this.model,
        backupDocument: this.backupDocument,
        evaluationInformation: this.evaluationInformation,
        elegibilityDetermination: this.elegibilityDetermination,
        instrumentInfo: this.instrumentInfo,
        peiInitialLocation: this.peiInitialLocation,
        observers: this.observers,
        evaluations: this.evaluations,
        instrumentsOptions: this.instrumentsOptions,
        postRegistryInstruments: this.postRegistryInstruments,
        isValidDate: this.isValidDate,
        resources: this.resources,
        selectedInstrumentId: this.selectedInstrumentId,
        showPerformedBy: this.showPerformedBy,
        serverEvaluationErrorMessage: this.serverEvaluationErrorMessage,
        selectedEvaluationModels: this.selectedEvaluationModels,
        eligibilityInfoModel: this.eligibilityInfoModel,
        HasValidEvaluationSelection: this.HasValidEvaluationSelection,
        selectedAllEvaluations: this.selectedAllEvaluations,
        IsEvaluationsDisabled: this.IsEvaluationsDisabled,
        IsDeterminationDisabled: this.IsDeterminationDisabled,
        canEditTab6: this.canEditTab6,
        signatureCounter: this.signatureCounter,
        signatureList: this.signatureList,
        signatures: this.signatures,
        elegibilitySignatureList: this.elegibilitySignatureList,
        componentKey: this.componentKey,
        availableSignatureOptions: this.availableSignatureOptions,
        participationTypeList: this.participationTypeList,
        alternateParticipationTypeList: this.alternateParticipationTypeList,
        validateComponent: this.validateComponent,
      });
    },
    recoverEditedData() {
      const registryTriannualEvaluation = this.$store.getters
        .registryTriannualEvaluation;
      if (!registryTriannualEvaluation) return;
      this.sectionCollapse = registryTriannualEvaluation.sectionCollapse;
      this.fieldModelElegibility =
        registryTriannualEvaluation.fieldModelElegibility;
      this.isRegistryBreachOver =
        registryTriannualEvaluation.isRegistryBreachOver;
      this.readonly = registryTriannualEvaluation.readonly;
      this.throwSaved = registryTriannualEvaluation.throwSaved;
      this.initialDateErrorMessage =
        registryTriannualEvaluation.initialDateErrorMessage;
      this.canShowInitialEvaluationValidationMessage =
        registryTriannualEvaluation.canShowInitialEvaluationValidationMessage;
      this.initialEvaluationValidationMessage =
        registryTriannualEvaluation.initialEvaluationValidationMessage;
      this.evaluationServiceType =
        registryTriannualEvaluation.evaluationServiceType;
      this.isInitialPostRegistry =
        registryTriannualEvaluation.isInitialPostRegistry;
      this.isTermsResponsabilityAccept =
        registryTriannualEvaluation.isTermsResponsabilityAccept;
      this.canModifyPostRegisterLocation =
        registryTriannualEvaluation.canModifyPostRegisterLocation;
      this.canModifyPeiInitialDate =
        registryTriannualEvaluation.canModifyPeiInitialDate;
      this.model = registryTriannualEvaluation.model;
      this.backupDocument = registryTriannualEvaluation.backupDocument;
      this.evaluationInformation =
        registryTriannualEvaluation.evaluationInformation;
      this.elegibilityDetermination =
        registryTriannualEvaluation.elegibilityDetermination;
      this.instrumentInfo = registryTriannualEvaluation.instrumentInfo;
      this.peiInitialLocation = registryTriannualEvaluation.peiInitialLocation;
      this.observers = registryTriannualEvaluation.observers;
      this.evaluations = registryTriannualEvaluation.evaluations;
      this.instrumentsOptions = registryTriannualEvaluation.instrumentsOptions;
      this.postRegistryInstruments =
        registryTriannualEvaluation.postRegistryInstruments;
      this.isValidDate = registryTriannualEvaluation.isValidDate;
      this.resources = registryTriannualEvaluation.resources;
      this.selectedInstrumentId =
        registryTriannualEvaluation.selectedInstrumentId;
      this.showPerformedBy = registryTriannualEvaluation.showPerformedBy;
      this.serverEvaluationErrorMessage =
        registryTriannualEvaluation.serverEvaluationErrorMessage;
      this.selectedEvaluationModels =
        registryTriannualEvaluation.selectedEvaluationModels;
      this.eligibilityInfoModel =
        registryTriannualEvaluation.eligibilityInfoModel;
      this.HasValidEvaluationSelection =
        registryTriannualEvaluation.HasValidEvaluationSelection;
      this.selectedAllEvaluations =
        registryTriannualEvaluation.selectedAllEvaluations;
      this.IsEvaluationsDisabled =
        registryTriannualEvaluation.IsEvaluationsDisabled;
      this.IsDeterminationDisabled =
        registryTriannualEvaluation.IsDeterminationDisabled;
      this.canEditTab6 = registryTriannualEvaluation.canEditTab6;
      this.signatureCounter = registryTriannualEvaluation.signatureCounter;
      this.signatureList = registryTriannualEvaluation.signatureList;
      this.signatures = registryTriannualEvaluation.signatures;
      this.elegibilitySignatureList =
        registryTriannualEvaluation.elegibilitySignatureList;
      this.componentKey = registryTriannualEvaluation.componentKey;
      this.availableSignatureOptions =
        registryTriannualEvaluation.availableSignatureOptions;
      this.participationTypeList =
        registryTriannualEvaluation.participationTypeList;
      this.alternateParticipationTypeList =
        registryTriannualEvaluation.alternateParticipationTypeList;
      this.validateComponent = registryTriannualEvaluation.validateComponent;

      this.$forceUpdate();
    },
    goToAddStudentEvaluation() {
      this.saveEditedData();
      this.$router.push({
        name: 'student-evaluation-history-add',
        query: {
          from: this.$route.fullPath,
          studentSieId: this.model.studentSieId,
        },
      });
    },
    async getAsDiscussionData() {
      await this.getShowEvaluationDeterminationAsDiscussionParam();
      if (!this.evaluationInformation.showAsDiscussion) return;
      await this.loadDiscussionStatuses();
      await this.loadRejectionReasons();
    },
    async loadDiscussionStatuses() {
      const { data } = await getEvaluationDiscussionStatus();
      this.evaluationInformation.discussionCollections.discussionStatuses = [
        ...data,
      ];
    },
    async loadRejectionReasons() {
      const { data } = await getRejectionReasonsV2();
      this.evaluationInformation.discussionCollections.rejectionReasons = [
        ...data,
      ];
      this.evaluationInformation.discussionCollections.allRejectionReasons = [
        ...data,
      ];
    },
    async getShowEvaluationDeterminationAsDiscussionParam() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['ShowEvaluationDeterminationAsDiscussion'],
      });

      this.evaluationInformation.showAsDiscussion =
        data?.length > 0 && data[0].staticValue?.toLowerCase() == 'true';
    },
    redirectToStudentEvaluation() {
      this.$router.push({
        name: 'student-evaluation-history-add',
        query: {
          from: 'StudentRegistry',
          toward: {
            name: 'registry',
            query: {
              tab: 'RegistryEvaluationAndServices',
              preRegistryId: this.regStudentId,
            },
          },
        },
      });
    },
    setTempEvalState() {
      //Refactored
      //The model was updated with two-way binding
      let evaluationData = this.evaluationInformation.evaluationsModel;

      this.setPostRegistryState({
        ...this.postRegistryState,
        evaluationData,
      });
    },
    setFieldModelElegibility(fieldModelElegibility) {
      this.setPostRegistryState({
        ...this.postRegistryState,
        fieldModelElegibility,
      });
    },
    // Get data from student evaluations.
    async getEvaluations() {
      let url =
        '/api/studentregistry/studentevaluationsdate' +
        `?studentSieId=${this.selectedStudent.studentId}`;
      +`&studentId=${this.studentPreRegistry.regStudentId}`;

      const self = this;
      return await self
        .$ApiGet(url)
        .then((response) => {
          this.evaluations = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    async validatePostInitialEvaluationDate() {
      this.initialDateErrorMessage = '';
      let isTermsResponsabilityValid = true;
      let isFormValid = true;
      if (this.$refs.termsResponsability) {
        isTermsResponsabilityValid = await this.$refs.termsResponsability?.validate();
      }
      if (this.$refs.formValidator) {
        isFormValid = await this.$refs.formValidator?.validate();
      }
      if (!isFormValid || !isTermsResponsabilityValid) return false;

      //valida las fechas de evaluaciones cuando es registro inicial
      if (!this.isPostRegistry) {
        let input = {
          studentSieId: this.model.studentSieId,
          postInitialEvaluationDate: new Date(
            this.model.postInitialEvaluationDate
          ),
        };

        try {
          let { data: isValid } = await this.$ApiPost(
            `api/studentregistry/validateevaluationdatespostregistry`,
            input
          );
          return isValid;
        } catch ({ response: error }) {
          let errorMessage = error.data.message;
          this.ShowToast('Error', errorMessage, 'error');
          this.initialDateErrorMessage = errorMessage;
        }
      } else {
        return true;
      }
    },
    // Trigger validation and data saving process.
    async save() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Registro:
          await this.saveRegistryByRegister();
          return;
        case StudentStatuses.Evaluado:
          await this.saveRegistryByEvaluated();
          return;
        case StudentStatuses.Elegible:
          await this.saveRegistryByElegible();
          return;
        default:
          return;
      }
    },
    showInstrumentWarning() {
      if (this.canShowAddInstrumentSeccion) {
        if (
          this.postRegistryInstruments == null ||
          this.postRegistryInstruments.length == 0
        ) {
          this.ShowToast(
            '',
            'Es requerido al menos un instrumento para continuar con el post-registro.',
            this.toastType.Warning
          );
          return false;
        }
      }

      return true;
    },
    // Save from register in registered state.
    async saveRegistryByRegister() {
      const lateEvaluationReasonSectionIsValid =
        this.canShowEligibilitySection &&
        (this.model.isDeterminationLate || this.isRegistryBreachOver) &&
        this.$refs?.lateEvaluationReasonFormValidator
          ? await this.$refs?.lateEvaluationReasonFormValidator?.validate()
          : true;

      const rpReasonSectionIsValid =
        this.canShowEligibilitySection &&
        (this.model.isDeterminationLate || this.isRegistryBreachOver) &&
        this.$refs?.rpReasonFormValidator
          ? await this.$refs?.rpReasonFormValidator?.validate()
          : true;

      let isValid =
        this.showInstrumentWarning() &&
        (await this.validatePostInitialEvaluationDate());

      if (
        isValid &&
        this.isValidDate &&
        lateEvaluationReasonSectionIsValid &&
        rpReasonSectionIsValid
      ) {
        try {
          let request = this.getDataAsFormData();
          await this.$ApiPut(
            `api/studentregistry/reginitialpostregistry`,
            request
          );

          await this.loadRegStudent();
          this.selectedStudent.status = this.model.studentStatusName;

          this.ShowToast('Proceso exitoso', this.resources['0636'], 'success');
        } catch ({ response: error }) {
          this.ShowToast('Error', error.data.message, 'error');
        }
      } else {
        this.ShowToast('Alerta', this.resources[1908031], 'error');
      }
    },
    // Save from record in evaluated state.
    async saveRegistryByEvaluated() {
      let self = this;

      this.serverEvaluationErrorMessage = null;

      this.generateEvaluationInformationValidations();

      let elegibilitySectionIsValid =
        this.observers?.elegibility && this.observers?.elegibility?.validate
          ? await this.observers.elegibility.validate()
          : true;

      let isTermsResponsabilityValid = true;
      if (this?.$refs?.termsResponsability) {
        isTermsResponsabilityValid = await this.$refs.termsResponsability.validate();
      }
      const isValidImpediments = this.$refs.eligibilityDetermination?.validateImpediments();

      let evaluationSectionIsValid = true;

      let evalAndEligibilityInfo = this.eligibilityInfoModel || {};

      this.HasValidEvaluationSelection = this.selectedAllEvaluations;

      const eligibilityEvaluationInfo = this.evaluationsSelected;

      evalAndEligibilityInfo.eligibilityEvaluationInfo = eligibilityEvaluationInfo.map(
        (x) => ({
          ...x,
          rejectionById: x.rejectionById?.id ?? x.rejectionById,
        })
      );

      await this.$ApiPost(
        `api/studentregistry/validate/${this.model.studentSieId}/evaluationsandeligibility`,
        evalAndEligibilityInfo || {}
      )
        .then(() => {
          self.serverEvaluationErrorMessage = null;
        })
        .catch(function(err) {
          evaluationSectionIsValid = false;

          // Some of the error messages must be displayed in a specific section
          self.handleEvaluationsAndElegibilityErrorResponse(err.response.data);
        });

      let participantsSectionIsValid =
        !this.signatureList.filter(
          (f) =>
            (f.isRequired && f.signature.name == '') ||
            f.signature.positionId == undefined ||
            f.signature.participationId == undefined ||
            (f.signature.participationId == 1 &&
              f.participationId.alternateId == undefined)
        ).length > 0;

      const lateEvaluationReasonSectionIsValid =
        this.canShowEligibilitySection &&
        this.model.isDeterminationLate &&
        this.$refs?.lateEvaluationReasonFormValidator
          ? await this.$refs?.lateEvaluationReasonFormValidator?.validate()
          : true;

      const rpReasonSectionIsValid =
        this.canShowEligibilitySection &&
        this.model.isDeterminationLate &&
        this.$refs?.rpReasonFormValidator
          ? await this.$refs?.rpReasonFormValidator?.validate()
          : true;
      if (
        participantsSectionIsValid &&
        elegibilitySectionIsValid &&
        evaluationSectionIsValid &&
        isValidImpediments &&
        isTermsResponsabilityValid &&
        lateEvaluationReasonSectionIsValid &&
        rpReasonSectionIsValid
      ) {
        const isEligible =
          this.$refs.eligibilityDetermination?.field?.radioElegibility?.model ??
          (this.elegibilityDetermination?.data?.isElegibility == '1'
            ? true
            : false);

        const hasRejectedEvaluations = (this.evaluationsSelected ?? []).some(
          (x) => x.discussionStatusId === discussionStatuses.rejected
        );
        // JSF: US92489 - If the student is not eligible, the user must confirm that the student will be changed to Egreso status.
        if (!isEligible && hasRejectedEvaluations) {
          let isConfirmed = await this.ShowCancelModal(
            'Confirmación',
            `<div class="mb-3"> Al continuar con esta acción, el estudiante cambiará a estatus Egreso. Esto dejará sin efecto lo siguiente:</div>
                <ul>
                  <li class="mb-2"> Cancelará los referidos activos de evaluaciones </li>
                  <li class="mb-2"> Cancelará los referidos de terapia cambiaran a estatus No Vigente: Egreso </li>
                  <li class="mb-2"> Los proveedores de servicios no podrán facturas servicios a partir de esta fecha. </li>
                  <li class="mb-2"> Cancelará la elegibilidad para las solicitudes de transportación escolar. </li>
                </ul>
              `,
            'Si',
            'No'
          );

          if (!isConfirmed) {
            return;
          }
        }

        this.throwSaved = true;

        this.generateAndSendData();

        this.enableSignatureTab();
      } else {
        this.incompleteInformation();

        //Force Signature Validation
        for (let i = 0; i < this.signatureList.length; i++) {
          this.signatureList[i].isRequired = true;
        }
      }
    },
    // Send request to save record in evaluated state.
    // Why there is a save for a student status when every save is using the same endpoint >/
    async sendForSaveRegistryByEvaluated() {
      this.serverEvaluationErrorMessage = null;
      const data = this.getDataAsFormData();
      let promise = await new Promise((resolve) => {
        let self = this;

        this.$ApiPut('/api/studentregistry/reginitialpostregistry', data)
          .then((response) => {
            self.ShowToast('Notificación', this.resources['0636'], 'success');
            this.throwSaved = true;
            resolve(response);
          })
          .catch(function(err) {
            self.incompleteInformation();

            // Some of the error messages must be displayed in a specific section
            self.handleEvaluationsAndElegibilityErrorResponse(
              err.response.data
            );

            this.throwSaved = false;
          });
      });

      if (this.throwSaved) {
        await this.loadRegStudent();
        this.selectedStudent.status = this.model.studentStatusName;
        this.selectedStudent.impediment = this.model.studentImpedimentName;
        await this.goToSignatureTabIfHasPendingSignature();
      }

      this.throwSaved = false;

      return promise;
    },
    handleEvaluationsAndElegibilityErrorResponse(response) {
      switch (response.code) {
        case '22148':
        case '22149':
        case '22150':
        case '22146':
        case '22147':
          this.serverEvaluationErrorMessage = response.message;
          break;
        default:
          // The toastr must be always displaying 'incomplete data' even if this method is not executed.
          break;
      }
    },
    async AddInstrument() {
      let isFormValid = await this.$refs.formInstrumentsValidator.validate();

      if (isFormValid) {
        try {
          let input = {
            RegStudentPostRegistryId: parseInt(
              this.model.regStudentPostRegistryId
            ),
            InstrumentId: this.instrumentInfo.InstrumentId.id,
            PerformedDate: new Date(this.instrumentInfo.PerformedDate),
            PerformedBy: this.instrumentInfo.PerformedBy,
            InitialIstrumentFlag: null,
          };

          await this.$ApiPut(
            '/api/studentregistry/insertregstudentpostregistryinstrument',
            input
          );

          await this.GetPostRegistryInstruments();
          await this.GetRegStudentLastEvaluationDate();

          this.instrumentInfo.InstrumentId = null;
          this.instrumentInfo.PerformedDate = null;
          this.instrumentInfo.PerformedBy = null;

          this.ShowToast('Proceso exitoso', this.resources['0636'], 'success');
        } catch ({ response: error }) {
          this.ShowToast('Error', error.data.message, 'error');
        }
        await this.$refs.formInstrumentsValidator.reset();
      }
    },
    async RemoveInstrument(regstudentpostregistryid, instrumentid) {
      try {
        await this.$ApiDelete(
          `api/studentregistry/deletepostregistryinstrument/${regstudentpostregistryid}/${instrumentid}`
        );

        await this.GetPostRegistryInstruments();

        this.ShowToast(
          'Proceso exitoso',
          this.resources['0636'],
          this.toastType.Success
        );
      } catch ({ response: error }) {
        this.ShowToast('Error', error.data.message, this.toastType.Error);
      }
    },
    async changeInitialEvaluationFlag() {
      try {
        let regstudentpostregistryid = parseInt(
          this.model.regStudentPostRegistryId
        );
        await this.$ApiPost('api/studentregistry/hasactiveevaluations', {
          regStudentPostRegistryId: regstudentpostregistryid,
        });

        let question = '';
        if (this.studentPreRegistry.hasInitialEvaluationFlag == 1) {
          question = this.resources['4683501'];
        } else {
          question = this.resources['4683502'];
        }
        const answer = await alert.methods.ShowCancelModal(
          'Aviso',
          question,
          'Sí',
          'No'
        );
        if (answer) {
          await this.$ApiPost(
            'api/studentregistry/changeinitialevaluationflag',
            { regStudentPostRegistryId: regstudentpostregistryid }
          ).then((response) => {
            this.studentPreRegistry.hasInitialEvaluationFlag = response.data;
            let tabList = [6];
            if (response.data == 0) {
              tabList.push(5);
            } else {
              this.$emit('set-visibility', [5], false);
            }

            this.$emit('set-visibility', tabList, true);
          });

          await this.loadRegStudent();

          this.ShowToast(
            'Proceso exitoso',
            this.resources['0636'],
            this.toastType.Success
          );
        }
      } catch ({ response: error }) {
        this.ShowToast('Error', error.data.message, this.toastType.Error);
      }
    },
    //  Save from record in elegible state.
    async saveRegistryByElegible() {
      let data = this.getDataAsFormData();

      let isTermsResponsabilityValid = true;
      if (this?.$refs?.termsResponsability) {
        isTermsResponsabilityValid = await this.$refs.termsResponsability.validate();
      }

      let sectionPeiInitialLocation = this.observers.peiinitiallocation
        ? await this.observers.peiinitiallocation.validate()
        : true;

      if (sectionPeiInitialLocation && isTermsResponsabilityValid) {
        let promise = await new Promise((resolve) => {
          let self = this;

          this.$ApiPut('/api/studentregistry/reginitialpostregistry', data)
            .then((response) => {
              self.ShowToast('Notificación', this.resources['0636'], 'success');
              resolve(response);
            })
            .catch(function(err) {
              self.ShowToast('Error', err.response.data.message, 'error');
            });
        });
        await this.loadRegStudent();
        this.selectedStudent.status = this.model.studentStatusName;

        return promise;
      } else {
        this.incompleteInformation();
      }
    },
    // Trigger event to get data from the EvaluationInformation component.
    async generateEvaluationInformation() {
      this.evaluationInformation.get = true;
      // Waiting for data $emit.
      await this.$nextTick();
      this.evaluationInformation.get = false;
    },
    // Trigger event to get data from the EvaluationInformation validations component.
    async generateEvaluationInformationValidations() {
      this.evaluationInformation.getValidation = true;
      // Waiting for data $emit.
      await this.$nextTick();
      this.evaluationInformation.getValidation = false;
    },
    // Trigger event to get data from the EligibilityDetermination component.
    async generateEligibilityDetermination() {
      this.elegibilityDetermination.get = true;
      // Waiting for data $emit.
      await this.$nextTick();
      this.elegibilityDetermination.get = false;
    },
    // Events Handlers.
    // Generate data for send.
    async generateAndSendData() {
      // Step one.
      await this.generateEvaluationInformation();
    },
    //JA: Evaluation Changed handler (Until this component is refactored)
    onEvaluationDataChanged(data) {
      this.selectedAllEvaluations = data.selectedAllEvaluations;
      this.selectedEvaluationModels = data.evaluations;
    },
    //JA: Eligibility panel data changed handler (Until this component is refactored)
    onEligibilityDataChanged(data) {
      this.eligibilityInfoModel = data;
    },
    // Getting data from EvaluationInformation component.
    async gettingEvaluationInformation(data) {
      // Avoid launching send by component event.
      if (!this.throwSaved) return;

      this.evaluationInformation.data = JSON.parse(JSON.stringify(data));

      // Step two. Validations.
      this.evaluationInformation.evaluationAcceptedAndDetermined = this.evaluationAcceptedAndDetermined();
      this.evaluationInformation.allEvaluationsAcceptedOrRejected = this.allEvaluationsAcceptedOrRejected();

      if (
        !this.evaluationInformation.evaluationAcceptedAndDetermined ||
        !this.evaluationInformation.allEvaluationsAcceptedOrRejected
      ) {
        this.incompleteInformation();
        return;
      }

      // Step three. If validations ok.
      await this.generateEligibilityDetermination();
    },
    // Getting data from EligibilityDetermination component.
    async gettingEligibilityDetermination(data) {
      this.elegibilityDetermination.data = JSON.parse(JSON.stringify(data));

      // Step four.
      this.sendForSaveRegistryByEvaluated();
    },
    // Getting data from BackupDocument component.
    async gettingBackupDocument(data) {
      this.backupDocument.data = data;
    },
    // Event when selecting determination.
    // Note JA: Determination of "what?" ... this is executed when an evaluation is determinated >\
    async onDeterminated(event) {
      this.elegibilityDetermination.show = event;
    },
    // Event when selecting row.
    async onSelected(event) {
      if (!event.isSelectedFlag && event.isDeterminated) {
        this.elegibilityDetermination.show = false;
      } else if (event.isSelectedFlag && event.isDeterminated) {
        this.elegibilityDetermination.show = true;
      }
    },
    // Validations.
    // Event when validation component.
    async onValidations(event) {
      this.evaluationInformation.evaluationAcceptedAndDetermined = event.evaluationAcceptedAndDetermined
        ? event.evaluationAcceptedAndDetermined
        : false;
      this.evaluationInformation.allEvaluationsAcceptedOrRejected = event.allEvaluationsAcceptedOrRejected
        ? event.allEvaluationsAcceptedOrRejected
        : false;
    },
    // Validates that there is an evaluation in an accepted and determined state.
    evaluationAcceptedAndDetermined() {
      if (this.evaluationInformation.data) {
        return this.evaluationInformation.data.some(
          (x) => x.isApprovedByParentFlag == true && x.isDeterminated == true
        );
      }
      return false;
    },
    // Validates that all evaluations are in an accepted or rejected state.
    allEvaluationsAcceptedOrRejected() {
      if (this.evaluationInformation.data) {
        return this.evaluationInformation.data.every(
          (x) =>
            x.isApprovedByParentFlag == true ||
            x.isApprovedByParentFlag == false
        );
      }
      return false;
    },
    validDate() {
      const self = this;
      self.isValidDate = false;

      if (!this.isPostRegistry) {
        self.evaluations.map((val) => {
          let eva = moment(val).format('DD/MM/YYYY');
          let sel = moment(self.model.postInitialEvaluationDate).format(
            'DD/MM/YYYY'
          );

          if (sel == eva) {
            self.isValidDate = true;
          }
        });
      } else {
        self.isValidDate = true;
      }
    },
    // Notification of incomplete data.
    async incompleteInformation() {
      this.ShowToast('Alerta', this.resources[1908031], 'error');
    },
    // Convert json to dataform.
    getDataAsFormData() {
      let data = {};
      switch (this.model.studentStatus) {
        case StudentStatuses.Registro: {
          data = {
            regStudentId: this.model.regStudentId,
            studentSieId: this.model.studentSieId,
            postInitialEvaluationDescription: this.model
              .postInitialEvaluationDescription,
            studentStatus: this.model.studentStatus,
            postInitialEvaluationDate: this.model.postInitialEvaluationDate,
            regStudentPostRegistryId: this.model.regStudentPostRegistryId,
            // Late evaluation reasons.
            lateEvaluationReason: this.model.lateEvaluationReason,
            lateEvaluationReasonDescription: this.model
              .lateEvaluationReasonDescription,
            rpLateEvaluationReason: this.model.rpLateEvaluationReason,
            rpLateEvaluationReasonDescription: this.model
              .rpLateEvaluationReasonDescription,
          };
          break;
        }
        case StudentStatuses.Evaluado: {
          return this.getDataAsFormDataByEvaluated();
        }
        case StudentStatuses.Elegible: {
          data = {
            regStudentId: this.model.regStudentId,
            studentSieId: this.model.studentSieId,
            peiInitialDate: this.peiInitialLocation.peiInitialDate,
            postAlternatePlacementDate: this.peiInitialLocation
              .postAlternatePlacementDate,
            postPeiAlternatePlacementCode: this.peiInitialLocation
              .peiAlternatePlacement.id,
            postAlternatePlacementDescription: this.peiInitialLocation
              .postAlternatePlacementDescription,
            studentStatus: this.model.studentStatus,
            regStudentPostRegistryId: this.model.regStudentPostRegistryId,
          };
          break;
        }
        default:
          break;
      }

      if (this.model.isDeterminationLate) {
        const eligibilityModel = this.eligibilityInfoModel || {};

        data.tardinessComment = eligibilityModel.tardinessComment;
        data.tardinessReasonId = eligibilityModel.tardinessReasonId;
      }

      // Convert json to formdata.
      return objectToFormData(data, { indices: true });
    },
    getDataAsFormDataByEvaluated() {
      this.elegibilityDetermination.data.impedimentMultipleSelected.forEach(
        (impediment) => {
          impediment.partialHearingFlag =
            impediment.partialHearingFlag == 'true' ? '1' : '0';
        }
      );
      const eligibilityModel = this.eligibilityInfoModel || {};

      const data = {
        regStudentId: this.model.regStudentId,
        studentSieId: this.model.studentSieId,
        tardinessComment: eligibilityModel.tardinessComment,
        tardinessReasonId: eligibilityModel.tardinessReasonId,
        postInitialEvaluationDescription: this.model
          .postInitialEvaluationDescription,
        studentStatus: this.model.studentStatus,
        postInitialEvaluationDate: this.model.postInitialEvaluationDate,
        regStudentPostRegistryId: this.model.regStudentPostRegistryId,
        elegibilityInfo: {
          eligibilityDeterminationDate: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.eligibilityDeterminationDate
            : null,
          eligibilityFlag: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.isElegibility
              ? '1'
              : '0'
            : null,
          impedimentId: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.impedimentSelected
            : null,
          impedimentPartialHearingFlag: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.isPartialDeaf
              ? '1'
              : '0'
            : null,
          impedimentSeverityCode: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.severitySelected
            : null,
          impedimentAutismCode: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.disorderSelected
            : null,
          eligibilityComment: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.comment
            : null,
          healthSpecialistParticipationFlag: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.isParticipatedSpecialist
              ? '1'
              : '0'
            : null,
          healthSpecialistParticipatedFlag: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.isHealthSpecialistNecessary
              ? '1'
              : '0'
            : null,
          postEligibilityMeetingsQty: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.numberMeetingsSelectEligibility
            : null,
          eligibilityEvaluationInfo: (this.evaluationsSelected ?? []).map(
            (x) => ({
              ...x,
              rejectionById: x.rejectionById?.id ?? x.rejectionById,
            })
          ),
          multipleImpedimentInfo: this.elegibilityDetermination.data
            ? this.elegibilityDetermination.data.impedimentMultipleSelected
            : null,
          attendanceInfo: this.getSignatureList(),
          conditionsInProcessNecessaryFlag:
            eligibilityModel.conditionsInProcessNecessaryFlag,
          eligibilityDeterminationConditions:
            eligibilityModel.eligibilityDeterminationConditions,
          impedimentsOptions: eligibilityModel.impedimentsOptions,
          dissabilityOption: eligibilityModel.dissabilityOption,
        },
        placementCommittee: {
          committeeDate: new Date(),
          academicYearId: this.model.academicYearId,
          committeeDescription: this.placementCommittee
            ? this.placementCommittee.description
            : null,
          placementCommitteeCategoryId: this.placementCommittee
            ? this.placementCommittee.categoryId
            : null,
        },
      };

      // Convert json to formdata.
      let formData = null;
      if (
        this.backupDocument.data != null &&
        this.backupDocument.data.types != null &&
        this.backupDocument.data.types.length > 0
      ) {
        data.documentTypes = this.backupDocument.data.types;

        formData = objectToFormData(data, { indices: true });
        this.backupDocument.data.files.map((file) => {
          formData.append(`files`, file);
        });
      } else {
        formData = objectToFormData(data, { indices: true });
      }

      return formData;
    },
    // Helpers.
    discardChanges() {
      // here goes the discard changes method for setting the data to the default values or value stored in db
      // this method is for being called when the user doesn't want the new changes to be applied when
      // leaving this tab.
    },
    getError(error) {
      if (error) return error;
      return this.initialDateErrorMessage;
    },
    async loadResources() {
      let resourceCodes = [
        '0527',
        '0636',
        '17020',
        '17021',
        '22144',
        '22145',
        '1908031',
        'R03200108',
        '4683501',
        '4683502',
        '17057',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );

      this.resources['0527'] = this.resources['0527'].replace(' ({0})', '');
    },
    // Get the observer to allow validating the component.
    async getObserver(id, observer) {
      this.observers = {
        ...this.observers,
        [id]: observer,
      };
    },
    // Filling data in components.
    fillComponents() {
      this.fillEligibilityEvaluation();
      this.fillDocuments();
      this.fillDetermination();
      this.fillPeiInitialLocation();
      this.fillPostRegistryInstruments();
      this.getInstrumentOptions();
    },
    // Filling component eligibility evaluations.
    fillEligibilityEvaluation() {
      this.model.eligibilityInfo.eligibilityEvaluationInfo.forEach((e) => {
        e.isDeterminated = e.isImpedimentEvaluationFlag;

        if (typeof e.evaluationDate == 'string') {
          let format = e.evaluationDate.replace(/\//gi, '-').substring(0, 10);
          e.evaluationDate = new Date(format);
        }
      });

      if (this.evaluationInformation?.evaluationsModel == null)
        this.evaluationInformation.evaluationsModel = this.model.eligibilityInfo.eligibilityEvaluationInfo;
    },
    fillPostRegistryInstruments() {
      if (this.isPostRegistry) {
        this.postRegistryInstruments = this.model.postRegistryInstruments;
      }
    },
    async getInstrumentOptions() {
      let url = '/api/pei/requirepostregistryinstruments';

      const self = this;
      return await self
        .$ApiGet(url)
        .then((response) => {
          this.instrumentsOptions = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    async GetPostRegistryInstruments() {
      if (this.isPostRegistry) {
        let regstudentpostregistryid = this.model.regStudentPostRegistryId;

        let url = `api/studentregistry/getregstudentpostregistryinstruments/${regstudentpostregistryid}`;

        const self = this;
        return await self
          .$ApiGet(url)
          .then((response) => {
            this.model.postRegistryInstruments = response.data;

            this.fillPostRegistryInstruments();
          })
          .catch((errm) => {
            self.ShowToast(errm.message, '', 'error');
          });
      }
    },
    async GetRegStudentLastEvaluationDate() {
      if (this.isPostRegistry) {
        let regstudentpostregistryid = this.model.regStudentPostRegistryId;

        let url = `api/studentregistry/getregstudentlastevaluationdate/${regstudentpostregistryid}`;

        const self = this;
        return await self
          .$ApiGet(url)
          .then((response) => {
            this.model.postInitialEvaluationDate = response.data;
          })
          .catch((errm) => {
            self.ShowToast(errm.message, '', 'error');
          });
      }
    },
    async validateInitialEvaluationConfirmed() {
      if (!this.isPostRegistry) {
        this.canShowInitialEvaluationValidationMessage = false;
        this.initialEvaluationValidationMessage = '';

        switch (this.model.studentStatus) {
          case StudentStatuses.Evaluado:
          case StudentStatuses.Registro:
            await this.$ApiPost(
              'api/studentregistry/validateinitialevaluationconfirmed',
              {
                regStudentId: this.studentPreRegistry.regStudentId,
              }
            ).then(async (res) => {
              if (res && res.data) {
                if (res.data.message != null && !res.data.isValid) {
                  this.canShowInitialEvaluationValidationMessage = true;
                  this.initialEvaluationValidationMessage = res.data.message;
                }
              }
            });
            break;
        }
      }
    },
    // Filling component documents.
    fillDocuments() {
      if (
        this.model.eligibilityInfo &&
        this.model.eligibilityInfo.documentAttachmentInfo &&
        this.model.eligibilityInfo.documentAttachmentInfo.length > 0
      ) {
        this.backupDocument.data.documentTypes = [];
        this.backupDocument.data.files = [];
        this.model.eligibilityInfo.documentAttachmentInfo.forEach((element) => {
          this.backupDocument.data.files.push({
            name: element.documentName,
            documentType: element.documentTypeId,
            id: element.documentId,
            inServer: true,
          });
          this.backupDocument.data.documentTypes.push(element.documentTypeId);
        });
      }
    },
    // Filling component determnination.
    fillDetermination() {
      this.elegibilityDetermination.eligibilityInfo = this.model.eligibilityInfo;
    },
    // Filling component initial location.
    fillPeiInitialLocation() {
      this.peiInitialLocation.peiInitialDate = this.model.peiInitialDate;
      this.peiInitialLocation.peiAlternatePlacement = {
        id: this.model.postPeiAlternatePlacementCode,
      };
      this.peiInitialLocation.eligibilityDeterminationDate = this.model
        .eligibilityInfo.eligibilityDeterminationDate
        ? new Date(this.model.eligibilityInfo.eligibilityDeterminationDate)
        : null;

      this.peiInitialLocation.postAlternatePlacementDate = this.model
        .postAlternatePlacementDate
        ? new Date(this.model.postAlternatePlacementDate)
        : null;

      this.peiInitialLocation.postAlternatePlacementDescription = this.model.postAlternatePlacementDescription;
    },
    async loadRegStudent() {
      const selectedStudent = this.selectedStudent;
      const selectedRegStudent = this.studentPreRegistry;

      let url = '';
      if (selectedRegStudent.isPostRegistry) {
        url = `api/studentregistry/getstudentpostregistry/${selectedRegStudent.regStudentPostRegistryId}`;
      } else {
        url = `api/studentregistry/studentInitialPostRegistry/${selectedRegStudent.regStudentId}`;
      }

      await this.$ApiGet(url).then((response) => {
        let data = response.data;
        data.regStudentId = selectedRegStudent.regStudentId;
        data.studentSieId = parseFloat(selectedStudent.studentId);

        if (this.isPostRegistry) {
          data.regStudentPostRegistryId =
            selectedRegStudent.regStudentPostRegistryId;
          this.evaluationServiceType = 2;
          this.isInitialPostRegistry = false;
        } else {
          this.evaluationServiceType = 1;
          this.isInitialPostRegistry = true;
        }

        if (data.postInitialEvaluationDate != undefined) {
          data.postInitialEvaluationDate = new Date(
            data.postInitialEvaluationDate
          );
        }

        if (data.registrationDate != undefined) {
          data.registrationDate = new Date(data.registrationDate);
        }

        if (data.regBreachDays !== undefined) {
          this.isRegistryBreachOver = data?.regBreachDays?.breachOver;
        }

        this.model = data;
        store.state.$_student.selectedStudent.status = data.studentStatusName;

        if (
          this.model.eligibilityInfo != null &&
          this.model.eligibilityInfo.attendanceInfo != null
        ) {
          this.elegibilitySignatureList = this.model.eligibilityInfo.attendanceInfo;
        }

        this.fillComponents();
        this.getEvaluations();

        if (data.studentStatusName.studentStatusName == 'Elegible') {
          let hasPermission = store.getters.HasPermission(
            'registry.enableplacementcontrols'
          );
          if (hasPermission) {
            this.canModifyPostRegisterLocation = true;
            this.canModifyPeiInitialDate = true;
          }
        }
      });
    },
    async goToSignatureTabIfHasPendingSignature() {
      await studentService
        .getHistorySign(store.getters.SelectedStudent.studentId)
        .then((data) => {
          if (data.data.length !== 0) {
            const result = data.data.find(
              ({ signatureType }) =>
                signatureType === null || signatureType === ''
            );
            if (result) this.goToSignatureTab();
          }
        });
    },
    //Signature Managment methods
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.validateComponent,
        isRemovable: true,
        isDisabled: false,
      });
    },

    deleteSignature(id) {
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    //Mejora al control (usar v-model para evitar estos cambios)
    getBasicSignature(groupId) {
      //TODO validate information about signatures
      let signature;
      if (this.elegibilitySignatureList != null) {
        signature = this.elegibilitySignatureList.find((x) =>
          this.availableSignatureOptions.some(
            (y) =>
              y.signatureGroupId == groupId &&
              y.signaturePositionId == x.positionId
          )
        );
      }
      if (signature != undefined) {
        return {
          id: signature.id,
          signature: {
            name: signature.fullName,
            positionId: { signaturePositionId: signature.positionId },
            participationId: { id: signature.participationType },
            alternateId: { id: signature.alternateParticipationType },
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false,
        };
      } else {
        this.signatureCounter -= 1;
        return {
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: undefined,
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: groupId,
          isRequired: this.validateComponent,
          isRemovable: false,
        };
      }
    },
    getSignatureList() {
      let self = this;
      let signatures = [];
      self.signatureList.forEach((x) => {
        let signInfo = {
          id: x.id,
          fullName: x.signature.name,
          positionId: x.signature.positionId?.signaturePositionId,
          participationType: x.signature.participationId?.id,
          alternateParticipationType: x.signature.alternateId
            ? x.signature.alternateId.id
            : undefined,
          attendanceGroupId:
            x.signature.positionId.signatureGroupId || x.groupId,
          IsRequired: !x.isRemovable,
        };
        signatures.push(signInfo);
      });
      return signatures;
    },
    loadSignatures() {
      let self = this;
      if (this.elegibilitySignatureList == undefined) {
        return;
      }
      this.elegibilitySignatureList.forEach(function(signature) {
        if (!self.signatureList.some((x) => x.id == signature.id)) {
          self.signatureList.push({
            id: signature.id,
            signature: {
              name: signature.fullName,
              positionId: { signaturePositionId: signature.positionId },
              participationId: { id: signature.participationType },
              alternateId: { id: signature.alternateParticipationType },
            },
            groupId: signature.groupId || signature.attendanceGroupId,
            isRequired: self.shouldValidate,
            isRemovable: !self.isDisabled,
            isDisabled: self.isDisabled, //self.submitted ? true : false,
          });
        }
      });
      //Remove all signatures with id = -1 disabled
      if (self.isDisabled) {
        let signaturesToRemove = this.signatureList.filter((x) => x.id < 0);
        if (this.signatureList.length > 3 && signaturesToRemove.length > 0) {
          //Only one
          signaturesToRemove.forEach((signature) => {
            this.deleteSignature(signature.id);
          });
        }
      }
    },
    async setSignatureConfig() {
      //** Positions for Signatures */ */
      let self = this;
      await signatureService.getPositions().then((result) => {
        self.availableSignatureOptions = result.data;
      });
      //*****signature Management********
      this.signatureList = [];
      //getting default Signatures
      let signature1 = this.getBasicSignature(1);
      if (signature1 != undefined) {
        this.signatureList.push(signature1);
      }
      let signature5 = this.getBasicSignature(5);
      if (signature5 != undefined) {
        this.signatureList.push(signature5);
      }

      let signature6 = this.getBasicSignature(4);
      if (signature6 != undefined) {
        this.signatureList.push(signature6);
      }
      this.loadSignatures();
    },
    addSpecialistSignature() {
      let existSpecialistRow = this.signatureList.find(
        (x) => !x.isRemovable && x.signature.positionId == 850
      );
      if (!existSpecialistRow) {
        this.signatureCounter -= 1;
        this.signatureList.push({
          id: this.signatureCounter,
          signature: {
            name: '',
            positionId: { signaturePositionId: 850 },
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: 13,
          isRequired: this.validateComponent,
          isRemovable: false,
          isDisabled: false, //Search PositionId for specialist
          positionDisabled: true,
        });
      }
    },
    removeSpecialistSignature() {
      //this.signatureList.push(specialistSignature);
      let existSpecialistRow = this.signatureList.find(
        (x) => !x.isRemovable && x.signature.positionId == 850
      );
      if (existSpecialistRow) {
        this.deleteSignature(existSpecialistRow.id);
      }
    },
    enableSignatureTab() {
      this.$emit('set-visibility', [7]);
    },
    goToSignatureTab() {
      this.$emit('select-tab', 7);
    },
    handleCollapse() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Evaluado:
        case StudentStatuses.Elegible:
          this.sectionCollapse.initialEvaluation = true;
          this.sectionCollapse.initialEligibilityDetermination = true;
          this.sectionCollapse.initialPEILocation = false;
          break;
        default:
          this.sectionCollapse.initialEvaluation = false;
          this.sectionCollapse.initialEligibilityDetermination = false;
          this.sectionCollapse.initialPEILocation = false;
          break;
      }
    },
    //End Signatures Methods
    ...mapMutations(['setPostRegistryState', 'setStudentPreRegistry']),
  },
  async activated() {
    this.$store.commit('setSaveMethod', this.save);
    this.$store.commit('setResetOriginalDataMethod', this.discardChanges);
    this.$store.commit(
      'setChangeInitEvaluationMethod',
      this.changeInitialEvaluationFlag
    );
    await this.loadRegStudent();
    await this.getAsDiscussionData();

    this.setSignatureConfig();

    if (this.studentStatus != StudentStatuses.PreRegistro)
      this.$emit('set-button-save-visibility', true);
  },
  async mounted() {
    await this.loadResources();

    //Load all Signatures (because we need load data if loaded)
    await signatureService.getParticipationTypeList().then((result) => {
      this.participationTypeList = result.data;
    });
    await signatureService
      .getAlternateParticipationTypeList()
      .then((result) => {
        this.alternateParticipationTypeList = result.data;
      });

    await this.validateInitialEvaluationConfirmed();

    if (this.postRegistryState != null) {
      this.elegibilityDetermination =
        this.postRegistryState.elegibility || this.elegibilityDetermination;
      this.fieldModelElegibility = this.postRegistryState.fieldModelElegibility;
      this.evaluationInformation.evaluationsModel = this.postRegistryState
        .evaluationData
        ? this.postRegistryState.evaluationData
        : this.evaluationInformation.evaluationsModel;
    }

    this.isTermsResponsabilityAccept = this.isReadOnlyEligibilitySection;
    this.handleCollapse();
    if (this.$store.getters.registryTriannualEvaluation) {
      this.recoverEditedData();
      this.$store.commit('setRegistryTriannualEvaluation', null);
    }
  },
  computed: {
    ...mapState(['postRegistryState']),
    selectedStudent() {
      return this.$store.getters['$_student/SelectedStudent'];
    },
    studentPreRegistry() {
      return this.$store.getters['$_student/getStudentPreRegistry'];
    },
    studentStatus() {
      return this.selectedStudent.status;
    },
    regStudentId() {
      return this.studentPreRegistry.regStudentId;
    },
    isPostRegistry() {
      return this.studentPreRegistry.isPostRegistry;
    },
    placementCommittee() {
      return {
        description: 'save',
        categoryId: this.setStudentPreRegistry.isPostRegistry ? 1 : 6,
      };
    },
    saveButtonVisibility() {
      if (
        this.studentStatus == 'No Elegible' ||
        this.studentStatus == 'Egreso' ||
        this.studentStatus == 'Inactivo' ||
        this.studentStatus == 'Servido'
      ) {
        return false;
      } else {
        return true;
      }
    },
    initialDate() {
      if (this.model.postInitialEvaluationDate != null)
        return moment(this.model.postInitialEvaluationDate).format(
          'DD/MMM/YYYY'
        );
      else return null;
    },
    // Return true, if the hasInitialEvaluationFlag is up.
    isInitialEvaluationReadOnly() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Evaluado:
        case StudentStatuses.Elegible:
        case StudentStatuses.NoElegible:
        case StudentStatuses.Servido:
        case StudentStatuses.Egreso:
          return (
            (this.model.postInitialEvaluationDate != null ||
              this.model.postInitialEvaluationDate != undefined) &&
            (this.model.hasInitialEvaluationFlag == '1' ||
              this.model.hasInitialEvaluationFlag == true)
          );
        default:
          return false;
      }
    },
    // Return true for determination section enabled, according to student status.
    canShowEligibilitySection() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Evaluado:
        case StudentStatuses.Elegible:
        case StudentStatuses.NoElegible:
        case StudentStatuses.Servido:
        case StudentStatuses.Egreso:
        case StudentStatuses.Registro:
          return true;
        default:
          return false;
      }
    },
    // Return true for determination section enabled, according to student status.
    canShowDeterminationSection() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Elegible:
        case StudentStatuses.NoElegible:
        case StudentStatuses.Servido:
        case StudentStatuses.Egreso:
          return true;
        default:
          return false;
      }
    },
    // Return true for pei initial location section enabled, according to student status.
    canShowPeiInitialLocationSection() {
      let hasPermission = store.getters.HasPermission(
        'student.register.initiallocation'
      );
      switch (this.model.studentStatus) {
        case StudentStatuses.Elegible:
        case StudentStatuses.Servido:
          return true && hasPermission;
        default:
          return false;
      }
    },
    hasInitialEvaluationFilled() {
      let hasData =
        this.model.postInitialEvaluationDate ||
        this.model.postInitialEvaluationDescription;
      switch (this.model.studentStatus) {
        case StudentStatuses.Registro:
          return this.isInitialEvaluationReadOnly && Boolean(hasData);
        default:
          return true;
      }
    },
    // Return true for save enabled, according to student status.
    canShowSave() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Servido:
        case StudentStatuses.Egreso:
        case StudentStatuses.NoElegible:
          this.$emit('set-button-save-visibility', false);
          return false;
        default:
          this.$emit('set-button-save-visibility', true);
          return true;
      }
    },

    // Determine read only.
    // Return true if section eligibility is read only.
    isReadOnlyEligibilitySection() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Registro:
          if (this.model.hasInitialEvaluationFlag == '0') {
            return false;
          } else {
            return false;
          }
        default:
          return true;
      }
    },
    isReadOnlyTardinessSection() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Registro:
          return false;
        default:
          return true;
      }
    },
    // Return true if section determination is read only.
    isReadOnlyDeterminationSection() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Evaluado:
          return false;
        default:
          return true;
      }
    },
    // Return true if section pei initial location is read only.
    isReadOnlyPeiInitialLocationSection() {
      switch (this.model.studentStatus) {
        case StudentStatuses.Elegible:
          return false;
        default:
          return true;
      }
    },
    canShowAddInstrumentSeccion() {
      if (
        this.model.requirePostRegistryInstrumentFlag == '1' &&
        this.model.hasInitialEvaluationFlag == '1'
      ) {
        switch (this.model.studentStatus) {
          case StudentStatuses.Registro:
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    canShowSelectedInstrumentSeccion() {
      if (
        this.model.requirePostRegistryInstrumentFlag == '1' &&
        this.model.hasInitialEvaluationFlag == '1'
      ) {
        return true;
      } else {
        return false;
      }
    },
    canShowEvaluationSeccion() {
      let canShow = true;

      if (
        this.model.requirePostRegistryInstrumentFlag == '1' &&
        this.isPostRegistry &&
        this.model.hasInitialEvaluationFlag == '1'
      ) {
        if (this.postRegistryInstruments.length == 0) {
          switch (this.model.studentStatus) {
            case StudentStatuses.Registro:
              canShow = false;
              break;
            default:
              canShow = true;
              break;
          }
        }
      }

      return canShow;
    },
    firstSectionTitle() {
      return this.isPostRegistry
        ? 'Evaluación adicional'
        : 'Evaluación Inicial';
    },
    tardinessInfo() {
      const model = this.model;
      return {
        isDeterminationLate: model.isDeterminationLate,
        tardinessReasons: model.tardinessReasons,
        tardinessComment: model.tardinessComment,
        tardinessReasonId: model.tardinessReasonId,
        rpTardinessReasons: model.rpTardinessReasons,
      };
    },
    showLateEvaluationReasonDescription() {
      return (
        this.model.lateEvaluationReason?.id === tardyRegistrationReasons.Otros
      );
    },
    showRPLateEvaluationReasonDescription() {
      return (
        this.model.rpLateEvaluationReason?.id === tardyRegistrationReasons.Otros
      );
    },
    readOnlyWithSpecificRole() {
      return (
        this.model.studentStatus == StudentStatuses.Evaluado &&
        (this.userRole === userRole.director ||
          this.userRole === userRole.maestro)
      );
    },
    tardinessReasonOptions() {
      const notElegibleReasons = [
        tardyRegistrationReasons.EstudianteSeEvaluoFuera30Dias,
        tardyRegistrationReasons.AusenciasRecurrentesPorPartePadresReunionDeterminacionElegibilidad,
      ];
      return this.tardinessInfo.tardinessReasons.filter(
        (t) => !notElegibleReasons.includes(t.id)
      );
    },
    evaluationsSelected() {
      return (
        this.selectedEvaluationModels ??
        this.model?.eligibilityInfo?.eligibilityEvaluationInfo ??
        this.elegibilityDetermination?.eligibilityInfo
          ?.eligibilityEvaluationInfo ??
        this.elegibilityDetermination?.data?.eligibilityEvaluationInfo ??
        []
      );
    },
  },
  watch: {
    'instrumentInfo.InstrumentId': function(nw) {
      this.showPerformedBy = nw.showPerformedBy;
    },
    'evaluationInformation.evaluationsModel': {
      handler: function() {
        this.setPostRegistryState({
          ...this.postRegistryState,
          evaluationData: this.evaluationInformation.evaluationsModel,
        });
      },
      deep: true,
    },
    elegibilityDetermination: {
      handler: function() {
        this.setPostRegistryState({
          ...this.postRegistryState,
          elegibility: this.elegibilityDetermination,
        });
      },
      deep: true,
    },
    fieldModelElegibility: {
      handler: function() {
        this.setPostRegistryState({
          ...this.postRegistryState,
          fieldModelElegibility: this.fieldModelElegibility,
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
p.reglular-text {
  font-weight: 100;
}
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.empty-table {
  background: #fafbfa 0% 0% no-repeat padding-box;
  opacity: 1;
}
.btn-border-green {
  width: 33px;
  height: 33px;
  border: 1px solid #2db782;
  border-radius: 4px;
  opacity: 1;
}
.btn-border-red {
  width: 33px;
  height: 33px;
  border: 1px solid #c9545e;
  border-radius: 4px;
  opacity: 1;
}
.dropdown-menu {
  margin-top: 1rem;
}
.dropdown-menu {
  margin-top: 1rem;
}
.dropleft .dropdown-toggle::before {
  display: none;
}
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}

.mv {
  margin-right: 1.75%;
}
.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}

form {
  width: 100%;
}

.error-margin-left {
  margin-left: -20px !important;
}

.custom-chips >>> .chips-container {
  -webkit-box-shadow: none !important;
  margin-top: -30px;
}

.custom-chips >>> .chips {
  margin-left: -2px;
  margin-right: 50px;
}

.b {
  font-weight: bolder !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.item-pane-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  margin-bottom: 10px;
  font: 400 14px/17px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 20px 10px 10px;
}

.item-pane-info p {
  margin-bottom: 10px;
}

.item-pane-info p i {
  margin-right: 8px;
  font-size: 16px;
}

.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}
.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}
i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
</style>
